import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeSession } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;

    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }

    exchangeSession(sessionId)
      .then((user) => {
        setUser(user);
        toast.success(`Welcome${user?.name ? `, ${user.name.split(" ")[0]}` : ""}!`);
      })
      .catch(() => {
        toast.error("Sign-in failed. Please try again.");
      })
      .finally(() => {
        // Clear the hash and go to home
        window.history.replaceState({}, document.title, "/");
        navigate("/", { replace: true });
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#09090B] text-zinc-300">
      <div className="flex items-center gap-3 font-mono text-sm uppercase tracking-widest">
        <Loader2 className="animate-spin" size={16} /> Signing you in…
      </div>
    </div>
  );
}
